import * as React from 'react';
import { Route, Switch } from 'react-router';

import SharedMaterialsDatabase from './SharedMaterialsDatabase';
import SharedMaterialsManagement from './SharedMaterialsManagement';
import SharedMaterialPublishPreview from './Detail/SharedMaterialPublishPreview';
import { ToxnotReactComponentPaths } from '../core/ToxnotReactComponentPaths';
import StaticPageReloader from '../StaticPageReloader';

// ==============================================================================

export default () => {
    return (
        <Switch>
            <Route exact={true} path={ToxnotReactComponentPaths.BaseSharedMaterialsPath} component={SharedMaterialsDatabase} />
            <Route exact={true} path={ToxnotReactComponentPaths.BaseSharedMaterialsPath + "/Start"} component={SharedMaterialsDatabase} />
            <Route exact={true} path={ToxnotReactComponentPaths.SharedMaterialPublishPreview + '/:publicInventoryId/:publicInventoryDataId/:mode?'} component={SharedMaterialPublishPreview} />
            <Route exact={false} path={ToxnotReactComponentPaths.BaseSharedMaterialsDatabasePath} component={SharedMaterialsDatabase} />
            <Route exact={false} path={ToxnotReactComponentPaths.BaseSharedMaterialsManagementPath} component={SharedMaterialsManagement} />
            <Route component={StaticPageReloader} />
        </Switch>
    );
}